<div class="container mg-top-title" *ngIf='isLogged'>
	<div class="row mg-account-menu">
		<div class="col d-none d-sm-none d-md-block" *ngFor="let item of myList" [ngClass]="[item.showActive ? 'active' : '']">
			<a href [routerLink]="item.link" [innerHTML]="item.title"></a>
		</div>
	</div>
</div>
